export const checkTokenExpiry = (exp: number) => {
  const remainingTimeInMins = (exp - Math.floor(Date.now() / 1000)) / 60;
  if (remainingTimeInMins < 1) {
    return true;
  }
  return false;
};
